<!-- 科一顺序随机 -->
<template>
    <div class="posre">
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            
            <div class="w1200 mauto pt50 pb50 overflow">
            <p class="fs24 fbold c333 pb20">
                <span>考试倒计时</span>
                <span class="c1f8 pl10">{{minute}}:{{second}}</span>
            </p>
                <div class=" disinblock w65p floatl">
                    <p class="fs30 c333">2020年小车科目一试题</p>
                    <div class="fs26 c333 mt20">
                        <p class="cursor alit mt25 mb25 borther answerParent ">
                            {{typeIndex+1}}、
                            {{practice.title}}
                        </p>
                        <div class="fs26 c333 mt20">
                            <p :class="{'aaaaa':once==1}" v-for="(item,index) in choose_listX" :key="index"
                                @click="choose(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther answerParent" ref="answerParent">
                                <!-- <img class="w30 h30 answerImg" :src="answerImg" alt="" ref="answerImg"> -->

                                <img v-if="item.T==0" class="w30 h30" src="../../public/img/img68.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==1" class="w30 h30" src="../../public/img/img67.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==2" class="w30 h30" src="../../public/img/img69.png" alt=""
                                    ref="answerImg">
                                <span class="disinblock ml16"> {{item.chose}} </span>
                            </p>
                            <div v-show="noteShow==1" class="fs16">{{practice.note}}</div>
                        </div>
                        <div v-show="practice.image" class="pl16 pr16 pt20 pb20">
                            <img class="w300 hauto bradius8 " :src="practice.image " alt="">
                        </div>
                        <div class="pt8 pb8 w100p overhidden">
                            <p class="overhidden  mauto">
                                <span @click="last()"
                                    class="border2e bradius25 fs20 cfff  bg1f8  floatl mr20 pl30 pr30 pt12 pb12 cursor">上一题</span>
                                <span @click="next()"
                                    class="border2e bradius25 fs20 disinblock floatl ml20 pl30 pr30 pt12 pb12 cfff bg1f8 cursor">下一题</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div  class=" disinblock w33p floatr">
                    <ul>
                        <li @click="againChoose(index)" ref="refClass" :class="{ 'leftColor':leftColorDisplay==index}"  class="refClass w35 baee5 h35 cursor lh35 textc disinblock" v-for="(item,index) in practiceList" :key="index"> 
                           <span class="refClass w35 baee5 h35 cursor lh35 textc disinblock bg3da" v-if="item.colorType==1">
                                {{index+1}}
                           </span>
                            <span class="refClass w35 baee5 h35 cursor lh35 textc disinblock bgred" v-if="item.colorType==2">
                                {{index+1}}
                            </span>
                            <!-- <span :class="{ 'leftColor':leftColorDisplay==index}"  class="refClass w35 baee5 h35 cursor lh35 textc disinblock bgred" v-if="item.colorType==3 && typeIndex==index">
                                {{index+1}}
                            </span> -->
                            <span   v-else class="refClass w35 baee5 h35 cursor lh35 textc disinblock ">
                                {{index+1}}
                            </span>
                        </li>
                    </ul>
                    <div class="mt40">
                        <span @click="Submit()"  class="cursor fs20 bradius25 bg1f8 cfff pl10 pr10 pt5 pb5"> 立即交卷 </span>
                        <span v-show="againMark==1" @click="againMark1()" class="cursor fs20 bradius8 bg1f8 cfff pl10 pr10 pt5 pb5 ml20">
                            重做一遍
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                schoolList2: [],
                index: 0,
                practice: { //练习题
                    title: '',
                    note: '',
                    answer: '', //正确答案
                    image: '',
                    title: '',
                    exercise_id: '', //题号
                },
                choose_listX: [], //选项
                practiceList: [],
                chooseList: [],
                typeIndex: 0,
                answerImg: require('../../public/img/img68.png'),
                once: 0,
                Already: [],
                subject: '',
                obj: '',
                km_typeX: '',
                orderX: '',
                noteShow: 0,
                Fraction: 0, //分数
                leftColorDisplay: 0,
                minutes: 45,
                seconds: 0,
                submit: 0,
                submitTxt: '立即交卷',
                againMark: 0
            };
        },
        inject: ['reload'],
        components: {
            Header,
            Footer,
        },
        methods: {
            getPractice() {
                let that = this;

                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getExamSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                        // "order": 0
                    },
                    success: function(data) {
                        let typeIndex = that.typeIndex;
                        that.practice = data.obj[typeIndex];
                        that.practiceList = data.obj;
                        that.practice.image = data.obj[typeIndex].image;
                        that.practice.answer = data.obj[typeIndex].answer;
                        that.practice.note = data.obj[typeIndex].note;
                        let arr2 = data.obj[typeIndex].choose_list.split("|");
                        for (let i = 0; i < arr2.length; i++) {
                            let P = {
                                chose: arr2[i],
                                T: 0
                            }
                            that.choose_listX.push(P);
                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            next() {
                let that = this;
                if (that.practiceList.length != that.typeIndex + 1) {
                    that.typeIndex++;
                    that.Judgment();
                } else {
                    alert('这已经是最后一题了')
                }

            },
            last() {
                let that = this;
                if (that.typeIndex == 0) {
                    alert('这已经是第一题了')
                } else {
                    that.typeIndex--;
                    that.Judgment();
                }
            },
            Judgment() {
                let that = this;
                //let aa = that.$refs.answerImg;


                let getAlready = [];
                getAlready = that.$store.state.moniList1;
                that.choose_listX = []
                that.markList = []

                that.leftColorDisplay = that.typeIndex;
                that.noteShow = 0;
                that.practice = that.practiceList[that.typeIndex];
                that.practice.e_typeX = that.practiceList[that.typeIndex].e_type;
                that.practice.image = that.practiceList[that.typeIndex].image;


                let arr2 = that.practice.choose_list.split("|");


                let markX = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1,
                };
                for (let i = 0; i < arr2.length; i++) {
                    let P = {
                        chose: arr2[i],
                        T: 0
                    }
                    that.choose_listX.push(P)
                    that.markList.push(markX)
                }
                for (let i = 0; i < getAlready.length; i++) {

                    if (getAlready[i].index == that.practice.exercise_id) { //getAlready[i].index做了的题
                        that.noteShow = 1;
                        if (getAlready[i].rigthFalse == true) {
                            that.once = 1;
                            console.log('对');
                            //item我选的那道题选项
                            //index1我选的那道题下标
                            console.log(that.choose_listX)

                            let P = {
                                chose: that.choose_listX[getAlready[i].index1].chose,
                                T: 1
                            }
                            that.choose_listX.splice(getAlready[i].index1, 1, P)
                        } else {
                            let j = getAlready[i].index1;
                            console.log('错误');

                            //循环选项
                            let itemX = that.practice.choose_list;

                            let P = {
                                chose: that.choose_listX[j].chose,
                                T: 2
                            }
                            that.choose_listX.splice(j, 1, P)

                            for (let jj = 0; jj < arr2.length; jj++) {
                                // console.log(getAlready[i]);
                                if (arr2[jj].indexOf(getAlready[i].answer) != -1) {
                                    let P = {
                                        chose: that.choose_listX[jj].chose,
                                        T: 1
                                    }
                                    that.choose_listX.splice(jj, 1, P)
                                        //that.$refs.answerImg[jj].src = require('../../public/img/img67.png');
                                }
                            }

                            //that.T = 2;
                            //that.$refs.answerImg[j].src = require('../../public/img/img69.png');
                        }
                        that.once = 1;
                        return;
                    } else {
                        that.once = 0;
                    }
                }

            },

            choose(item, answer, e, index, practice, index1) {
                let that = this;
                let rigth = '';
                that.once = 1;

                //console.log(this.$refs.refClass[index1]);
                let P = {
                    chose: that.choose_listX[index1].chose,
                    T: 1,
                }

                that.choose_listX.splice(index1, 1, P)

                if (item.indexOf(answer) != -1) {
                    that.Fraction++;
                    console.log('做对了');
                    that.practiceList[that.typeIndex].colorType = 1
                    rigth = true;

                } else {
                    console.log('做错了')
                    that.practiceList[that.typeIndex].colorType = 2
                    rigth = false;
                }
                let mark = {
                    item: item,
                    index: index,
                    index1: index1,
                    rigthFalse: rigth,
                    answer: answer,
                };

                setTimeout(that.next, 300);
                let getAlready = that.$store.state.moniList1; //取vuex缓存'
                console.log(111)
                console.log(index)
                that.Already.splice(that.typeIndex, 1, mark)
                that.$forceUpdate()
                that.$store.dispatch('Moni1').then(() => {
                    that.$store.state.moniList1 = that.Already;
                });



            },
            Submit() {
                let that = this;
                if (confirm("是否交卷")) {
                    this.$router.push({
                        path: "/Achievements",
                        query: {
                            kemu: 1,
                            fenshu: that.Fraction
                        }
                    });
                    // if (that.Fraction < 90) {
                    //     alert('您的分数为' + that.Fraction + '分！' + ' 不及格，您是马路杀手')
                    // } else {
                    //     alert('您的分数为' + that.Fraction + '分！' + 'good! 您是秋名山车神')
                    // }
                    // that.submit = 1;
                    // that.submitTxt = "您的分数为 " + that.Fraction + ' 分！';
                    // that.againMark = 1;
                    return true;
                } else {
                    return false;
                }
            },
            againChoose(index) {
                let that = this;
                this.typeIndex = index;
                this.practice = this.practiceList[index];
                that.leftColorDisplay = that.typeIndex;
                let getAlready = that.$store.state.moniList1; //取vuex缓存'
                this.Judgment();
            },
            tiku() {
                console.log("页面打开清空数据")
                this.$store.dispatch('Moni1', '')
            },
            num: function(n) {
                return n < 10 ? "0" + n : "" + n
            },
            add: function() {
                var that = this;
                var time = window.setInterval(function() {
                    if (that.seconds == "00" && that.minutes != "00") {
                        that.seconds = 59;
                        that.minutes -= 1;
                    } else if (that.minutes == "00" && that.seconds == "00") {
                        that.seconds = 0;
                        window.clearInterval(time);
                        if (confirm("考试时间到,是否立即交卷")) {
                            if (that.Fraction < 90) {
                                alert('您的分数为' + that.Fraction + '分！' + ' 不及格，您是马路杀手')
                            } else {
                                alert('您的分数为' + that.Fraction + '分！' + 'good! 您是秋名山车神')
                            }
                            that.submit = 1;
                            that.submitTxt = "您的分数为 " + that.Fraction + ' 分！';
                            that.againMark = 1;
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        that.seconds -= 1
                    }

                }, 1000);
            },
            againMark1() {
                let that = this;
                setTimeout(() => {
                    that.reload()
                }, 500);
            }
        },
        watch: {
            second: {
                handler(newVal) {
                    this.num(newVal)
                }
            },
            minute: {
                handler(newVal) {
                    this.num(newVal)
                }
            }
        },
        computed: {
            second: function() {
                return this.num(this.seconds)
            },
            minute: function() {
                return this.num(this.minutes)
            },

        },
        created() {
            this.tiku();
            this.getPractice();
            //this.Judgment()
            let that = this;
            for (let i = 0; i < 100; i++) {
                let mark1 = {
                    item: '',
                    index: '',
                    index1: '',
                    rigthFalse: '',
                    answer: ''
                };
                that.Already.push(mark1)
                that.$forceUpdate()
                that.$store.dispatch('Moni1').then(() => {
                    that.$store.state.moniList1 = that.Already;
                });
            };
            this.add()
            this.cityName = this.$store.state.cityName;
        },
        mounted() {
            let that = this;
            if (window.performance.navigation.type == 1) {
                console.log("页面被刷新")
                that.once = 0;
                this.$store.dispatch('Moni1', '')
                console.log(that.Already)

            }


        }
    }
</script>
<style scoped>
    .aaaaa {
        pointer-events: none;
    }
    
    .leftColor {
        background: #1D6BD0;
        color: #fff;
    }
    
    .leftColor span {
        color: #fff;
    }
    
    .intro {
        background: #000;
    }
    
    .bg3da {
        background: #3da600;
        position: absolute;
    }
    
    .bgred {
        background: red;
    }
</style>